import React, {useContext, useState} from 'react';
import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import {toast} from 'react-toastify';
import {editProductSettings, getProductSettingsInfo} from '../../api/api';
import handleUnauthorized401MutateError from "../../utils/handleUnauthorized401MutateError";
import AuthContext from "../../context/AuthContext";
import {Input, Label, Button, Form} from "reactstrap";
import Loader from "../../components/Loader";

function ProductSettingsTab({ currentTab, setCurrentTab }) {
    const {refreshToken} = useContext(AuthContext);
    const queryClient = useQueryClient();
    const [settings, setSettings] = useState('');
    const [settingId, setSettingId] = useState(null);


    const {refetch} = useQuery({
        queryKey: ['product-settings'],
        queryFn: () => getProductSettingsInfo(),
        keepPreviousData : true,
        retry: false,
        onSuccess: (data) => {
            setSettingId(data.results[0].id);
            setSettings(data.results[0]);
        },
        onError: (err, variables) => {
            handleUnauthorized401MutateError(err, refreshToken, refetch);
            if (err.response.status !== 401) {
                toast.error(`An error occurred! ${err?.response?.data?.detail}`);
            }
        }
    });

    const mutation = useMutation(editProductSettings, {
        onSuccess: () => {
            toast.success('Product Settings updated successfully!');
            queryClient.invalidateQueries(['product-settings']);
        },
        onError: (err) => {
            toast.error(`An error occurred! ${err?.response?.data?.detail}`);
        },
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSettings((prevSettings) => ({
            ...prevSettings,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        mutation.mutate({ formData: settings, settingId });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <div className="row">
                <div className="settings-card ml-3">
                    <div className="card-box">
                        <div className="form-group">
                            <Label>Default Product HSN/SAC Code</Label>
                            <Input
                                type="text"
                                name="default_product_hsn_sac"
                                className="form-control"
                                value={settings.default_product_hsn_sac}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Label>Default Product Unit of Measure</Label>
                            <Input
                                type="text"
                                name="default_product_unit_of_measure"
                                className="form-control"
                                value={settings.default_product_unit_of_measure}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Label>Default Product Tax Type</Label>
                            <Input
                                type="select"
                                name="default_product_tax_type"
                                className="form-control"
                                value={settings.default_product_tax_type}
                                onChange={handleChange}
                            >
                                <option value="TAX-EXCLUSIVE">TAX-EXCLUSIVE</option>
                                <option value="TAX-INCLUSIVE">TAX-INCLUSIVE</option>
                            </Input>
                        </div>
                        <div className="form-group">
                            <Label>Default Product Tax Percentage</Label>
                            <Input
                                type="text"
                                step="0.01"
                                name="default_product_tax_percentage"
                                className="form-control"
                                value={settings.default_product_tax_percentage}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group">
                            <Label>Default Product Status</Label>
                            <Input
                                type="select"
                                name="default_product_status"
                                className="form-control"
                                value={settings.default_product_status}
                                onChange={handleChange}
                            >
                                <option value="ACTIVE">ACTIVE</option>
                                <option value="INACTIVE">INACTIVE</option>
                            </Input>
                        </div>
                        <Button type="submit" className="btn bx-btn-primary waves-effect waves-light" disabled={mutation.isLoading}>{mutation.isLoading? <><Loader size={'small'}/>Saving...</>: `Save`}</Button>
                    </div>
                </div>
            </div>
        </Form>
    );
}

export default ProductSettingsTab;
